import { useContext } from 'react';
import AuthContext from '../Context/AuthContext';

// Custom hook to use AuthContext in components
const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
